<template>
  <div class="info animate slideInRight">
    <p class="infoTop">
      lane19，欢迎使用lanniuzai.com!<br/>
      在您回到浏览网站之前，<br/>
      请告诉我们更多关于您!
    </p>
    <p class="skipBtn cur show" @click="closed">暂时跳过<a class="rbtn show"></a></p>
    <div class="logInfo">
      <uL class="putlist fleft">
        <li><input class="inputcls" value="" :placeholder=" $t('lan.userName') " /></li>
        <li><input class="inputcls" value="" :placeholder=" $t('lan.datebirth') "/></li>
        <li><input class="inputcls" value="" :placeholder=" $t('lan.compy') "/></li>
        <li><input class="inputcls" value="" :placeholder=" $t('lan.posit') "/></li>
        <li><input class="inputcls" value="" :placeholder=" $t('lan.coungj') " /></li>
        <li><input class="inputcls" value="" :placeholder=" $t('lan.phone') " /></li>
      </uL>
      <span class="btnsub show fleft cur">{{$t('lan.savecont')}}</span>
      <p class="infoJs m40T fleft">
        为啥要填写好账户信息呢?<br/>
        √ 获得500积分到您的帐户<br/>
        √ 享受首次购物的折扣优惠券<br/>
        √ 您可能有资格升级到10MB的小样图<br/>
        √ 蓝牛仔可以给您更好的针对性服务
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
    
  },
  props:{

  },
  data(){
    return {
      
    }
  },
  created() {
    
  },
  mounted(){

  },
  destroyed(){
   
  },
  methods:{
    closed(){
      this.$emit('closeReg',true)
    },
    toLog(){
      this.$emit('closeType',1)
    },
    
  }
}
</script>
<style lang="scss" scoped>
    .info{
      width:750px;
      margin:0 auto;
      background: #404040;
      height:100%;
      position: fixed;
      top:0;
      left: 0;
      z-index: 2000;
      background:url(../assets/wap/regbg.jpg) no-repeat;
      background-size:750px 1306px;
    }
    .close{
      background:url(../assets/wap/icon_close.png) no-repeat;
      background-size:43px 43px;
      position:absolute;
      right:37px;
      top:37px;
      width:43px;
      height:43px;
    }
    .infoTop{
      font-size:20px;
      line-height:30px;
      height:90px;
      text-align: left;
      position: absolute;
      left:60px;
      top:45px;
      color:#fff;
      
    }
    .skipBtn{
      height:30px;
      font-size:20px;
      position: absolute;
      top:45px; 
      right:40px;
      color:#fff;
      padding-right:35px;
      line-height:30px;
      .rbtn{
        background:url(../assets/wap/icon_skip.png) no-repeat;
        background-size:16px 30px;
        width:16px;
        height:30px;
        position: absolute;
        top:0; 
        right:0;
      }
    }
    .logInfo{
      width:450px;
      height:700px;
      position:absolute;
      top:50%;
      left:50%;
      margin:-350px 0 0 -225px;
      color:#fff;
      font-size:26px;
      .logo{
        width:100%;
        height:100px;
        text-align: center;
        img{
          width:300px;
          height:90px;
        }
      }
      .tit{
        width:100%;
        line-height:80px;
        font-size:30px;
        text-align: center;
        height:80px;
      }
      .putlist{
        width:100%;
        height:434px;
        li{
          width:100%;
          margin-bottom:2px;
          float: left;
          height:70px;
          .inputcls{
            width:410px;
            height:70px;
            line-height:70px;
            background: rgba(255,255,255,.9);
            padding:0 20px;
          }
        }
      }
      .btnsub{
        width:100%;
        height:70px;
        line-height:70px;
        background:#0ca1ea;
        color:#fff;
        text-align: center;
        float: left;
      }
      .infoJs{
        font-size:20px;
        line-height:30px;
        text-align: center;
        width:100%;
        height:150px;
      }
    }
    
</style>
